import React, { useState } from "react";
import {
  Grid,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
  Paper,
  Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TicketDisplay from "../TicketDisplay/TicketDisplay";
import TicketsImage from "../../../../Images/bands.png";
import BandsImage from "../../../../Images/tickets.png";
import { AllTypoFontStyles } from "../../../../Styles/styles";
import { useDispatch, useSelector } from "react-redux";
import { setTicketCategory } from "../../../../Redux/Slices/ticketCategorySlice";
import { setSelectedTemplate } from "../../../../Redux/Slices/selectedTemplateSlice";
import Template1 from "./Templates/TicketTemplate/Template1";
import Ticket5 from "./Templates/TicketTemplate/Ticket5";
import Ticket6 from "./Templates/TicketTemplate/Ticket6";
import Ticket7 from "./Templates/TicketTemplate/Ticket7";
import Ticket8 from "./Templates/TicketTemplate/Ticket8";
import Ticket9 from "./Templates/TicketTemplate/Ticket9";
import Band1 from "./Templates/BandTemplate/Band1";
import Band2 from "./Templates/BandTemplate/Band2";
import Band3 from "./Templates/BandTemplate/Band3";

const CreateTicket = ({ selectedTicket, onTicketSelect, onBack, colors }) => {
  const payload = useSelector(
    (state) => state?.ticketPayload?.payload?.ticketTemplate
  );
  const [selectedType, setSelectedType] = useState(
    ["13", "14", "15"].includes(payload) ? "Band" : "Ticket"
  );
  const dispatch = useDispatch();
  const handleTypeChange = (event) => {
    setSelectedType(event.target.value);
  };
  dispatch(setTicketCategory(selectedType));

  const ticketTypes = [
    { value: "Ticket", label: "Pass", image: BandsImage },
    { value: "Band", label: "Band", image: TicketsImage },
  ];
  const ticketData = {
    id: 7,
    title: "ROAD TRIP",
    organizer: "Taylor Reilly",
    date: "July 29, 2024",
    time: "02:20 PM",
    code: "123-456-89",
    location: "123 Anywhere st., Any City",
    price: "20",
    qrCode: "",
    bgColor: "#E8E8E8",
    prevTicket: payload,
  };
  const ticketData5 = {
    id: 8,
    code: "123-465-89",
    title: "ART FESTIVAL",
    location: "123 Anywhere st., Any City",
    price: "20.00",
    position: "Organizer",
    organizer: "Taylor Reilly",
    date: "July 29,2024",
    monthDate: "July 29",
    time: "02:20 PM",
    type: "VIP",
    bgColor: "#e8e8e8",
    prevTicket: payload,
  };
  const ticketData6 = {
    id: 9,
    code: "123-465-89",
    title: "ART FESTIVAL",
    location: "123 Anywhere st., Any City",
    price: "20.00",
    position: "Organizer",
    organizer: "Taylor Reilly",
    date: "July 29,2024",
    time: "02:20 PM",
    type: "VIP",
    bgColor: "#e8e8e8",
    prevTicket: payload,
  };
  const ticketData7 = {
    id: 10,
    code: "0900-78601",
    title: "ART FESTIVAL",
    location: "123 Anywhere st., Any City",
    price: "20.00",
    position: "Organizer",
    organizer: "Taylor Reilly",
    date: "July 29,2024",
    time: "02:20 PM",
    type: "VIP",
    bgColor: "#e8e8e8",
    numberDate: "21/02/2025",
    organizedBy: "Organized by Taylor Reilly",
    prevTicket: payload,
  };
  const ticketData8 = {
    id: 11,
    code: "123-465-89",
    title: "Really Great Concert",
    location: "123 Anywhere st., Any City",
    price: "20.00",
    position: "Organizer",
    organizer: "Taylor Reilly",
    date: "July 29,2024",
    time: "02:20 PM",
    type: "VIP",
    bgColor: "#807C79",
    prevTicket: payload,
  };
  const ticketData9 = {
    id: 12,
    code: "123-465-89",
    title: "ART FESTIVAL",
    location: "123 Anywhere st., Any City",
    price: "20.00",
    position: "Organizer",
    organizer: "Taylor Reilly",
    date: "July 29,2024",
    time: "02:20 PM",
    type: "VIP",
    bgColor: "#e8753c",
    prevTicket: payload,
  };
  const bandData1 = {
    id: 13,
    code: "123-465-89",
    title: "ART FESTIVAL",
    location: "123 Anywhere st., Any City",
    price: "20.00",
    position: "Organizer",
    organizer: "Taylor Reilly",
    date: "July 29,2024",
    time: "02:20 PM",
    type: "VIP",
    bgColor: "#807C79",
    prevTicket: payload,
  };
  const band2 = {
    id: 14,
    code: "123-465-89",
    title: "ART FESTIVAL",
    location: "123 Anywhere st., Any City",
    price: "20.00",
    position: "Organizer",
    organizer: "Taylor Reilly",
    date: "July 29,2024",
    time: "02:20 PM",
    type: "VIP",
    bgColor: "#00AC4F",
    prevTicket: payload,
  };
  const band3 = {
    id: 15,
    code: "123-465-89",
    title: "ART FESTIVAL",
    location: "123 Anywhere st., Any City",
    price: "20.00",
    position: "Organizer",
    organizer: "Taylor Reilly",
    date: "July 29,2024",
    time: "02:20 PM",
    type: "VIP",
    bgColor: "#B12A2F",
    prevTicket: payload,
  };

  const containerStyle = {
    padding: "10px",
    width: "100%",
  };

  const imageStyle = {
    height: "100%",
    width: "100%",
    objectFit: "contain",
  };

  const circleIcon = {
    position: "absolute",
    bottom: "-5px",
    right: "-5px",
    color: "#1976d2",
    background: "white",
    borderRadius: "50%",
  };

  // optimized:

  const handleTemplateClick = (ticketData) => {
    setSelectedTemplate(ticketData);
    onTicketSelect(ticketData);
    dispatch(setSelectedTemplate(ticketData.id));
  };
  const handleBandTemplateClick = (bandData) => {
    setSelectedTemplate(bandData);
    onTicketSelect(bandData);
    dispatch(setSelectedTemplate(bandData.id));
  };

  const templateItems = [
    {
      component: Template1,
      data: ticketData,
      condition: selectedType === "Ticket",
    },
    {
      component: Ticket5,
      data: ticketData5,
      condition: selectedType === "Ticket",
    },
    {
      component: Ticket6,
      data: ticketData6,
      condition: selectedType === "Ticket",
    },
    {
      component: Ticket7,
      data: ticketData7,
      condition: selectedType === "Ticket",
    },
    {
      component: Ticket8,
      data: ticketData8,
      condition: selectedType === "Ticket",
    },
    {
      component: Ticket9,
      data: ticketData9,
      condition: selectedType === "Ticket",
    },
    { component: Band1, data: bandData1, condition: selectedType === "Band" },
    { component: Band2, data: band2, condition: selectedType === "Band" },
    { component: Band3, data: band3, condition: selectedType === "Band" },
  ];

  return (
    <div style={containerStyle}>
      {selectedTicket ? (
        <>
          <TicketDisplay
            onTicketSelect={onTicketSelect}
            item={selectedTicket}
            colors={colors}
          />
        </>
      ) : (
        <>
          <Grid container>
            <Grid item xs={12} md={12}>
              <Typography sx={AllTypoFontStyles.CommonTypo0}>
                Ticket Categories:
              </Typography>
              <FormGroup row>
                {ticketTypes.map((type) => (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      textAlign: "center",
                    }}
                  >
                    <Paper
                      key={type.value}
                      variant="outlined"
                      style={{
                        margin: "5px",
                        display: "flex",
                        alignItems: "center",
                        border:
                          selectedType === type.value
                            ? "2px solid #1976d2"
                            : "1px solid #ccc",
                        cursor: "pointer",
                        position: "relative",
                        borderRadius: 5,
                      }}
                      onClick={() => setSelectedType(type.value)}
                    >
                      <Checkbox
                        checked={selectedType === type.value}
                        onChange={handleTypeChange}
                        value={type.value}
                        icon={
                          <Box
                            sx={{
                              width: { xs: 100, sm: 200 },
                              height: { xs: 100, sm: 200 },
                              borderRadius: 3,
                            }}
                          >
                            <img
                              src={type.image}
                              alt={type.label}
                              style={imageStyle}
                            />
                          </Box>
                        }
                        checkedIcon={
                          <Box
                            sx={{
                              width: { xs: 100, sm: 200 },
                              height: { xs: 100, sm: 200 },
                            }}
                          >
                            <img
                              src={type.image}
                              alt={type.label}
                              style={imageStyle}
                            />
                          </Box>
                        }
                        style={{ display: "none" }}
                      />
                      <FormControlLabel
                        control={
                          <Box
                            sx={{
                              width: { xs: 100, sm: 200 },
                              height: { xs: 100, sm: 200 },
                            }}
                          >
                            <img
                              src={type.image}
                              alt={type.label}
                              style={imageStyle}
                            />
                          </Box>
                        }
                        style={{
                          margin: 0,
                          color:
                            selectedType === type.value ? "#1976d2" : "black",
                        }}
                      />
                      {selectedType === type.value && (
                        <CheckCircleIcon style={circleIcon} />
                      )}
                    </Paper>
                    <Typography>{type.label}</Typography>
                  </div>
                ))}
              </FormGroup>
            </Grid>
          </Grid>

          <Typography
            sx={{
              ...AllTypoFontStyles.CommonTypo0,
              marginTop: "1rem",
              marginBottom: "1rem",
            }}
          >
            Tickets:
          </Typography>
          <Grid
            container
            spacing={2}
            columns={12}
            sx={{
              marginBottom: { xs: "0rem", sm: "4rem" },
              overflow: "hidden",
            }}
          >
            {templateItems.map(
              (item, index) =>
                item.condition && (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={6}
                    xl={6}
                    key={index}
                    sx={{
                      overflowX: "auto",
                      overflowY: "hidden",
                      flexWrap: "wrap",
                      "@media (min-width: 1900px)": {
                        flex: "0 0 33.33%",
                        maxWidth: "33.33%",
                      },
                    }}
                  >
                    <div
                      style={{
                        height: "100%",
                        cursor: "pointer",
                        overflowX: "auto",
                        overflowY: "hidden",
                        scrollbarWidth: "thin",
                        minWidth: "450px",
                      }}
                      onClick={() =>
                        item.condition === "Ticket"
                          ? handleTemplateClick(item.data)
                          : handleBandTemplateClick(item.data)
                      }
                    >
                      <item.component ticket={item.data} />
                    </div>
                  </Grid>
                )
            )}
          </Grid>
        </>
      )}
    </div>
  );
};

export default CreateTicket;
